import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {HttpCommonService} from "./http-common.service";

@Injectable()
export class MyQueryHistoryService {

  constructor(private http: HttpCommonService) {
  }

  /**
   * 添加查询历史
   * @param {string} context
   * @returns {Observable<any>}
   */
  addQueryHistory(context: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/Query/addQueryHistory', {queryContent: context});
  }

  /**
   * 获取查询历史
   * @returns {Observable<any>}
   */
  getQueryHistory(context: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/Query/getQueryHistory', {queryContent: context});
  }

  /**
   * 删除查询历史
   * @param {string} queryContent
   * @returns {Observable<any>}
   */
  deleteQueryHistory(queryContent: string): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/Query/deleteQueryHistory', {queryContent: queryContent});
  }

  /**
   * 删除全部查询历史
   * @returns {Observable<any>}
   */
  deleteAllHistory(): Observable<any> {
    return this.http.get('/enterprise/detail/xhsRest/Query/deleteQueryHistoryAll');
  }
}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/services/my-query-history.service.ts